import React, {createContext, useReducer} from "react";
import {FilterReducer, initial_state} from "@reducers/filter.reducer";

export const FilterContext = createContext();
export const FilterDispatcherContext = createContext();

function FilterProvider({children}) {
    const [filterState, filterDispatch] = useReducer(FilterReducer, initial_state);

    return (
        <FilterContext.Provider value={filterState}>
            <FilterDispatcherContext.Provider value={filterDispatch}>
                {children}
            </FilterDispatcherContext.Provider>
        </FilterContext.Provider>
    )
}

export default FilterProvider;
